module.exports = __webpack_public_path__ + "static/media/pag-QueroSerLojista-ebit-07.2090c49e.2090c49e.png";